declare namespace $ {

	type $shm_hitalama_map_widget_contextmenu_copy_id__Map_page_shm_hitalama_map_widget_contextmenu_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu_copy_id['Map_page'] >
	>
	type $shm_hitalama_map_widget_contextmenu_copy_id__title_shm_hitalama_map_widget_contextmenu_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu_copy_id['title'] >
	>
	type $shm_hitalama_map_widget_contextmenu_copy_id__text_shm_hitalama_map_widget_contextmenu_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['ref_str'] >
		,
		ReturnType< $shm_hitalama_map_widget_contextmenu_copy_id['text'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_contextmenu_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['fullscreen'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_contextmenu_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['open_props'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_contextmenu_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['open_in_editor'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_contextmenu_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['to_front'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_contextmenu_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['to_back'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_contextmenu_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['customizer_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_contextmenu_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['make_extension'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_contextmenu_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['quick_access_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_contextmenu_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['quick_access_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_contextmenu_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_contextmenu['contextmenu_common'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_map_widget_contextmenu extends $mol_view {
		ref_str( ): string
		Copy_id( ): $shm_hitalama_map_widget_contextmenu_copy_id
		Fullscreen_icon( ): $mol_icon_arrow_expand_all
		fullscreen( next?: any ): any
		Fullscreen( ): $mol_button_minor
		open_props( next?: any ): any
		Open_props( ): $mol_button_minor
		Open_in_editor_icon( ): $mol_icon_code_braces
		open_in_editor( next?: any ): any
		Open_in_editor( ): $mol_button_minor
		open_in_editor_visible( ): readonly(any)[]
		Top_icon( ): $mol_icon_arrow_collapse_up
		to_front( next?: any ): any
		To_front( ): $mol_button_minor
		Bottom_icon( ): $mol_icon_arrow_collapse_down
		to_back( next?: any ): any
		To_back( ): $mol_button_minor
		customizer_add( next?: any ): any
		Customize( ): $mol_button_minor
		make_extension( next?: any ): any
		Make_extension( ): $mol_button_minor
		quick_access_title( ): string
		quick_access_toggle( next?: any ): any
		Quick_access( ): $mol_button_minor
		contextmenu_common( ): readonly(any)[]
		widget( ): $shm_hitalama_map_widget
		Map_page( ): $shm_hitalama_map_page
		Contextmenu_common( ): $mol_list
	}
	
	export class $shm_hitalama_map_widget_contextmenu_copy_id extends $mol_button_copy {
		Map_page( ): $shm_hitalama_map_page
	}
	
}

//# sourceMappingURL=contextmenu.view.tree.d.ts.map